module.exports = __webpack_public_path__ + "static/dear-green-places-a917ad021ed62afd678d66abd50020d9.jpg";